module.exports = __webpack_public_path__ + "img/whats-new-12_en.cf05449.jpg";